import { __decorate, __metadata } from "tslib";
import { AppRequest } from '@core/shared/app-request';
import { ConfiguratedValidator, Default, EditorDefinition, Expose, IsString, Model, ModelId } from '@core/shared/model';
import { AppRequestMethod } from '@core/shared/request';
import { requireEmailIfUsernameIsNoEmailUserItemValidator } from '@common/users/shared/validators';
let PasswordResetByMailResponse = /*#__PURE__*/(() => {
  let PasswordResetByMailResponse = class PasswordResetByMailResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", Boolean)], PasswordResetByMailResponse.prototype, "success", void 0);
  PasswordResetByMailResponse = __decorate([ModelId("PasswordResetByMailResponse") // auto-generated by generate-model-ids
  ], PasswordResetByMailResponse);
  // generates a mail with link pointing to "begin-session-by-url" routerLinkResolver -> CoreBeginSessionByUrlComponent
  return PasswordResetByMailResponse;
})();
let PasswordResetByMailRequest = /*#__PURE__*/(() => {
  let PasswordResetByMailRequest = class PasswordResetByMailRequest extends Model {
    static {
      this.Response = PasswordResetByMailResponse;
    }
  };
  __decorate([ConfiguratedValidator(requireEmailIfUsernameIsNoEmailUserItemValidator), Expose(), Default(''), __metadata("design:type", String)], PasswordResetByMailRequest.prototype, "email", void 0);
  __decorate([IsString(), Expose(), Default(''), __metadata("design:type", String)], PasswordResetByMailRequest.prototype, "username", void 0);
  PasswordResetByMailRequest = __decorate([AppRequest('auth/credentials', 'password-reset/mail-callback', {
    httpMethod: AppRequestMethod.POST
  }), EditorDefinition({}, {
    allowAllExposed: true,
    useAppRequest: true
  }), ModelId("PasswordResetByMailRequest") // auto-generated by generate-model-ids
  ], PasswordResetByMailRequest);
  return PasswordResetByMailRequest;
})();
export { PasswordResetByMailRequest };
// generates a mail with link pointing to "begin-session-by-url" routerLinkResolver -> CoreBeginSessionByUrlComponent
let PasswordResetMailByAdminRequest = /*#__PURE__*/(() => {
  let PasswordResetMailByAdminRequest = class PasswordResetMailByAdminRequest extends Model {
    static {
      this.Response = PasswordResetByMailResponse;
    }
  };
  __decorate([Expose(), __metadata("design:type", Number)], PasswordResetMailByAdminRequest.prototype, "userId", void 0);
  PasswordResetMailByAdminRequest = __decorate([AppRequest('auth/credentials', 'password-reset/by-admin', {
    httpMethod: AppRequestMethod.POST,
    simpleAbilityCheck: ['ADMINISTRATOR']
  }), EditorDefinition({}, {
    allowAllExposed: true,
    useAppRequest: true
  }), ModelId("PasswordResetMailByAdminRequest") // auto-generated by generate-model-ids
  ], PasswordResetMailByAdminRequest);
  return PasswordResetMailByAdminRequest;
})();
export { PasswordResetMailByAdminRequest };